// routes/AppRoutes.js
import { Routes, Route } from "react-router-dom";
import { useState } from "react";
import Home from "../Home";
import About from "../About";
import Login from "../auth/Login";
import Dashboard from "../dashboard/Dashboard";
import Plans from "../plan/Plan";
import Customers from "../customer/Customers";
import DigitalMedia from "../wallpapers/DigitalMedia";
import HomeScreenSettings from "../home/HomeScreenSettings";
import ComingSoon from "../ComingSoon";
import ProtectedRoute from "./ProtectedRoute";
import Sidebar from "../sidebar/Sidebar";
import Header from "../header/Header";
import "../App.css";
import Ringtones from "../ringtones/Ringtones";
import HomeTabs from "../HomeTabs/HomeTabs";

export default function AppRoutes({ darkMode, setDarkMode }) {
  const [collapsed, setCollapsed] = useState(false);

  // Layout component for protected routes
  const ProtectedLayout = ({ children }) => {
    return (
      <div className={`app-layout ${darkMode ? 'dark' : ''}`}>
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
        
        <div className={`main-content ${collapsed ? 'collapsed' : ''}`}>
          <Header 
            collapsed={collapsed} 
            setCollapsed={setCollapsed}
            darkMode={darkMode}
            setDarkMode={setDarkMode}
          />
          
          <div className="content-wrapper">
            {children}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Routes>
      {/* Public Routes - No Layout */}
      <Route path="/" element={<Login />} />
      <Route path="/coming-soon" element={<ComingSoon />} />

      {/* Protected Routes with Layout */}
      <Route element={<ProtectedRoute />}>
        <Route 
          path="/dashboard" 
          element={
            <ProtectedLayout>
              <Dashboard darkMode={darkMode} />
            </ProtectedLayout>
          } 
        />
        <Route 
          path="/plans" 
          element={
            <ProtectedLayout>
              <Plans darkMode={darkMode} />
            </ProtectedLayout>
          } 
        />
        <Route 
          path="/home-tabs" 
          element={
            <ProtectedLayout>
              <HomeTabs darkMode={darkMode} />
            </ProtectedLayout>
          } 
        />
        <Route 
          path="/customers" 
          element={
            <ProtectedLayout>
              <Customers darkMode={darkMode} />
            </ProtectedLayout>
          } 
        />
        <Route 
          path="/payments" 
          element={
            <ProtectedLayout>
              <ComingSoon darkMode={darkMode} />
            </ProtectedLayout>
          } 
        />
        <Route 
          path="/subscriptions" 
          element={
            <ProtectedLayout>
              <ComingSoon darkMode={darkMode} />
            </ProtectedLayout>
          } 
        />
        <Route 
          path="/settings" 
          element={
            <ProtectedLayout>
              <ComingSoon darkMode={darkMode} />
            </ProtectedLayout>
          } 
        />
        <Route 
          path="/digital-media" 
          element={
            <ProtectedLayout>
              <DigitalMedia darkMode={darkMode} />
            </ProtectedLayout>
          } 
        />
        <Route 
          path="/home-screen" 
          element={
            <ProtectedLayout>
              <HomeScreenSettings darkMode={darkMode} />
            </ProtectedLayout>
          } 
        />
        <Route 
          path="/ringtones" 
          element={
            <ProtectedLayout>
              <Ringtones darkMode={darkMode} />
            </ProtectedLayout>
          } 
        />
      </Route>
    </Routes>
  );
}